// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 347 ? "SVG" : chunkId) + "." + {"29":"98d6e22b","181":"0227f251","311":"8fdfdb5f","347":"7bf7eecb","389":"4d258c4e","434":"6f11898d","474":"90fb8ac2","487":"3039705d","915":"0ca4b167"}[chunkId] + ".chunk.js";
};